import { SET_PEGAWAIS, SET_PEGAWAI, SET_PEGAWAIS_ERROR, SET_PEGAWAIS_LOADING } from "../../actions/pegawaiAction";

var initialState = {
  datas: [],
  data: "",
  loading: false,
  error: null,
};

const pegawaiReducer = (state, action) => {
  state = state || initialState;
  switch (action.type) {
    case SET_PEGAWAIS:
      return {
        ...state,

        datas: action.data,
      };
    case SET_PEGAWAI:
      return {
        ...state,
        data: action.data,
      };
    case SET_PEGAWAIS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_PEGAWAIS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    default:
      return state;
  }
};

export default pegawaiReducer;
